// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ProtocolType } from "./protocol-type";

/**
 * Connection lifecycle.
 */
export class ConnectionSnapshot implements flatbuffers.IUnpackableObject<ConnectionSnapshotT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ConnectionSnapshot {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsConnectionSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: ConnectionSnapshot,
  ): ConnectionSnapshot {
    return (obj || new ConnectionSnapshot()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsConnectionSnapshot(
    bb: flatbuffers.ByteBuffer,
    obj?: ConnectionSnapshot,
  ): ConnectionSnapshot {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ConnectionSnapshot()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  peerAddress(): string | null;
  peerAddress(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  peerAddress(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  protocol(): ProtocolType {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ProtocolType.Unknown;
  }

  connected(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  attemptCount(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  backoffMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  sessionDurationMs(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  static startConnectionSnapshot(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addPeerAddress(builder: flatbuffers.Builder, peerAddressOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, peerAddressOffset, 0);
  }

  static addProtocol(builder: flatbuffers.Builder, protocol: ProtocolType) {
    builder.addFieldInt8(1, protocol, ProtocolType.Unknown);
  }

  static addConnected(builder: flatbuffers.Builder, connected: boolean) {
    builder.addFieldInt8(2, +connected, +false);
  }

  static addAttemptCount(builder: flatbuffers.Builder, attemptCount: number) {
    builder.addFieldInt32(3, attemptCount, 0);
  }

  static addBackoffMs(builder: flatbuffers.Builder, backoffMs: number) {
    builder.addFieldInt32(4, backoffMs, 0);
  }

  static addSessionDurationMs(builder: flatbuffers.Builder, sessionDurationMs: bigint) {
    builder.addFieldInt64(5, sessionDurationMs, 0n);
  }

  static endConnectionSnapshot(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createConnectionSnapshot(
    builder: flatbuffers.Builder,
    peerAddressOffset: flatbuffers.Offset,
    protocol: ProtocolType,
    connected: boolean,
    attemptCount: number,
    backoffMs: number,
    sessionDurationMs: bigint,
  ): flatbuffers.Offset {
    ConnectionSnapshot.startConnectionSnapshot(builder);
    ConnectionSnapshot.addPeerAddress(builder, peerAddressOffset);
    ConnectionSnapshot.addProtocol(builder, protocol);
    ConnectionSnapshot.addConnected(builder, connected);
    ConnectionSnapshot.addAttemptCount(builder, attemptCount);
    ConnectionSnapshot.addBackoffMs(builder, backoffMs);
    ConnectionSnapshot.addSessionDurationMs(builder, sessionDurationMs);
    return ConnectionSnapshot.endConnectionSnapshot(builder);
  }

  unpack(): ConnectionSnapshotT {
    return new ConnectionSnapshotT(
      this.peerAddress(),
      this.protocol(),
      this.connected(),
      this.attemptCount(),
      this.backoffMs(),
      this.sessionDurationMs(),
    );
  }

  unpackTo(_o: ConnectionSnapshotT): void {
    _o.peerAddress = this.peerAddress();
    _o.protocol = this.protocol();
    _o.connected = this.connected();
    _o.attemptCount = this.attemptCount();
    _o.backoffMs = this.backoffMs();
    _o.sessionDurationMs = this.sessionDurationMs();
  }

  unpackFields(...fields: string[]): ConnectionSnapshotT {
    const t = new ConnectionSnapshotT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("peer_address")) {
      t.peerAddress = this.peerAddress();
    }
    if (fieldSet.has("protocol")) {
      t.protocol = this.protocol();
    }
    if (fieldSet.has("connected")) {
      t.connected = this.connected();
    }
    if (fieldSet.has("attempt_count")) {
      t.attemptCount = this.attemptCount();
    }
    if (fieldSet.has("backoff_ms")) {
      t.backoffMs = this.backoffMs();
    }
    if (fieldSet.has("session_duration_ms")) {
      t.sessionDurationMs = this.sessionDurationMs();
    }
    return t;
  }
}

export class ConnectionSnapshotT implements flatbuffers.IGeneratedObject {
  constructor(
    public peerAddress: string | Uint8Array | null = null,
    public protocol: ProtocolType = ProtocolType.Unknown,
    public connected: boolean = false,
    public attemptCount: number = 0,
    public backoffMs: number = 0,
    public sessionDurationMs: bigint = 0n,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const peerAddress = this.peerAddress !== null ? builder.createString(this.peerAddress!) : 0;

    return ConnectionSnapshot.createConnectionSnapshot(
      builder,
      peerAddress,
      this.protocol,
      this.connected,
      this.attemptCount,
      this.backoffMs,
      this.sessionDurationMs,
    );
  }

  clone(): ConnectionSnapshotT {
    const obj = new ConnectionSnapshotT();
    obj.peerAddress = this.peerAddress;
    obj.protocol = this.protocol;
    obj.connected = this.connected;
    obj.attemptCount = this.attemptCount;
    obj.backoffMs = this.backoffMs;
    obj.sessionDurationMs = this.sessionDurationMs;
    return obj;
  }

  equals(other: ConnectionSnapshotT): boolean {
    if (this.peerAddress !== other.peerAddress) return false;
    if (this.protocol !== other.protocol) return false;
    if (this.connected !== other.connected) return false;
    if (this.attemptCount !== other.attemptCount) return false;
    if (this.backoffMs !== other.backoffMs) return false;
    if (this.sessionDurationMs !== other.sessionDurationMs) return false;
    return true;
  }
}

export function verifyConnectionSnapshot(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 4);
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 8);
  } finally {
    verifier.popDepth();
  }
}
